import React from "react";
import { LoadingLine } from "@thecb/components";
import { TableRow, TableRowEntry } from "@/components/generic/NewTable";

export const makeFakeRow = (columnWidths) => (
  <TableRow>
    {columnWidths.slice(0, -1).map((width, index) => (
      <TableRowEntry key={index}>
        <LoadingLine exactWidth={width} />
      </TableRowEntry>
    ))}
    <TableRowEntry
      key={columnWidths.length - 1}
      extraStyles="text-align: right; direction: rtl;"
    >
      <LoadingLine exactWidth={columnWidths.slice(-1)} />
    </TableRowEntry>
  </TableRow>
);
